import { Filter } from 'state/calendarFilter';
import AppConstants from 'constants/AppConstants';

export function updateQueryParams(newParams: Partial<Filter>): BaseTockAction {
  return {
    type: AppConstants.CALENDAR_FILTER_PARAMS_UPDATE,
    payload: newParams,
  };
}

export function clear(): BaseTockAction {
  return {
    type: AppConstants.CALENDAR_FILTER_CLEAR,
  };
}
